import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { JSX } from 'react'

import { ReportDraftsScreen } from './-components/report-drafts-screen.tsx'

export const Route = createFileRoute('/lab/report-drafts')({
  component: ReportDraftsPage
})

function ReportDraftsPage(): JSX.Element {
  const navigate = useNavigate()

  return (
    <ReportDraftsScreen
      onOpenDraft={id => {
        void navigate({ to: '/lab/report-draft', search: { id } })
      }}
    />
  )
}
